module.exports = __webpack_public_path__ + "static/media/calling.d66e5c7c.mp3";